import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
} from "chart.js";

import SectionLabel from "../../../app/universalComponents/SectionLabel";
import { palette } from "../../../app/utils/palette.js";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
);

export default function RevenueBreakdownWidget({ ticketTypes }) {
  const safeTicketTypes = Array.isArray(ticketTypes)
    ? ticketTypes.filter(Boolean).map((ticketType) => {
        const revenue = Number(ticketType?.revenue ?? 0);

        return {
          ...ticketType,
          name: ticketType?.name ?? "Unnamed ticket",
          revenue: Number.isFinite(revenue) ? revenue : 0,
        };
      })
    : [];

  const hasRevenue = safeTicketTypes.some(
    (ticketType) => ticketType.revenue > 0,
  );

  const revenueBreakdownData = {
    labels: safeTicketTypes.map((ticketType) => ticketType.name),
    datasets: [
      {
        data: safeTicketTypes.map((ticketType) => ticketType.revenue),
        backgroundColor: safeTicketTypes.map(
          (_, index) => palette[index % palette.length],
        ),
        borderWidth: 0,
        hoverOffset: 0,
      },
    ],
  };

  const emptyRevenueData = {
    labels: ["No revenue"],
    datasets: [
      {
        data: [1],
        backgroundColor: ["#d1d5db"],
        borderWidth: 0,
        hoverOffset: 0,
      },
    ],
  };

  const revenueBreakdownOptions = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "72%",
    rotation: -90,
    circumference: 180,
    events: [],
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
  };

  return (
    <article className="flex flex-col">
      <SectionLabel>Revenue Breakdown</SectionLabel>

      <div className="flex-1 rounded-sm border p-4">
        <div className="h-48">
          <Doughnut
            data={hasRevenue ? revenueBreakdownData : emptyRevenueData}
            options={revenueBreakdownOptions}
          />
        </div>

        <ul className="mt-4 space-y-2">
          {safeTicketTypes.map((ticketType, index) => (
            <li
              key={`${ticketType.name}-${index}`}
              className="flex items-center justify-between text-sm"
            >
              <div className="flex min-w-0 items-center gap-2">
                <span
                  className="shrink-0 text-base leading-none"
                  style={{
                    color: palette[index % palette.length],
                  }}
                >
                  ●
                </span>

                <span className="truncate font-semibold">
                  {ticketType.name}
                </span>
              </div>

              <span className="shrink-0">
                €{ticketType.revenue.toFixed(2)}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </article>
  );
}